"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyRadioGroup = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importDefault(require("react"));

const StyledRadioGroup = (0, material_1.styled)(material_1.RadioGroup)(({
  theme,
  row
}) => ({
  margin: `${theme.spacing(1)}px 0`,
  display: row ? "unset" : "flex"
}));
const StyledFormControlLabel = (0, material_1.styled)(material_1.FormControlLabel)({
  [`&.${material_1.formControlLabelClasses.root}`]: {
    height: 25,
    margin: "0 16px 10px -14px"
  }
});

const SskyRadioGroup = props => {
  var _a;

  const renderButtons = () => {
    return props.buttons.map((btn, idx) => {
      var _a;

      return react_1.default.createElement(StyledFormControlLabel, {
        classes: {
          root: (0, classnames_1.default)((_a = props.classes) === null || _a === void 0 ? void 0 : _a.root, btn.className)
        },
        key: btn.value,
        value: btn.value,
        label: btn.label,
        disabled: btn.disabled || props.disabled,
        onClick: btn.onClick,
        "data-testid": btn.dataTestId || `testId-${btn.value}`,
        control: react_1.default.createElement(material_1.Radio, {
          key: `${btn.value}-${idx}`,
          color: btn.color || "primary"
        })
      });
    });
  };

  return react_1.default.createElement(StyledRadioGroup, {
    id: props.id,
    className: (0, classnames_1.default)((_a = props.classes) === null || _a === void 0 ? void 0 : _a.root, props.className),
    value: props.value,
    onChange: props.onChange,
    "data-testid": props.dataTestId || `testId-${props.id}`,
    row: props.row
  }, renderButtons());
};

exports.SskyRadioGroup = SskyRadioGroup;
exports.default = react_1.default.memo(SskyRadioGroup);